export const brazilArgentinaIguazuProgram = {
  programKey: 'brazylia-i-argentyna-miejski-rytm-i-wodospady-iguazu',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Brazylia i Argentyna - Miejski rytm i wodospady Iguazu',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Brazylia i Argentyna:',
  stickySubtitle: 'Miejski rytm i wodospady Iguazu',

  pageUrl:
    'https://coolturystki.pl/wycieczki/brazylia-i-argentyna-miejski-rytm-i-wodospady-iguazu',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-brazylia-argentyna-iguazu-muqv09t4.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-brazylia-argentyna-iguazu-muqv09t4.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Brazylia i Argentyna'],
    continent: 'Ameryka Południowa',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-10-03',
  },

  /* Termin: 25 lutego - 9 marca 2027. */
  tripIds: [26],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '26': {
      pilotId: 'iza',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy i przeloty lokalne',
          description:
            'Z Warszawy lecimy do Rio de Janeiro z jedną przesiadką. Trasa obejmuje także bezpośrednie loty z Rio do Puerto Iguazú i dalej do Buenos Aires. Wracamy z Buenos Aires do Warszawy z jedną przesiadką.',
        },
        hotel: {
          title: 'Hotele 3★ i 4★ na trasie',
          description:
            'Jedenaście noclegów spędzamy w Rio de Janeiro, Foz do Iguaçu, Puerto Iguazú i Buenos Aires. Nocujemy w pokojach 2-osobowych, a każdy dzień rozpoczynamy od śniadania.',
        },
      },
    },
  },
}
